import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ClearFilterButtonProps {
  onClick: () => void;
  visible?: boolean;
}

export const ClearFilterButton = ({
  onClick,
  visible = true,
}: ClearFilterButtonProps) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <Button variant="secondary" onClick={onClick}>
      <X className="w-4 h-4" />
      {t("common.clear")}
    </Button>
  );
};
